import { render } from "./list-detail-panel.vue?vue&type=template&id=6dae331a&scoped=true&ts=true"
import script from "./list-detail-panel.vue?vue&type=script&lang=ts"
export * from "./list-detail-panel.vue?vue&type=script&lang=ts"

import "./list-detail-panel.vue?vue&type=style&index=0&id=6dae331a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dae331a"]])

export default __exports__